module.exports = __webpack_public_path__ + "img/spelling-course-5.09fb38fc.png";